import { render } from "./SemaphoreControl.vue?vue&type=template&id=4d7155c0&scoped=true"
import script from "./SemaphoreControl.vue?vue&type=script&lang=js"
export * from "./SemaphoreControl.vue?vue&type=script&lang=js"

import "./SemaphoreControl.vue?vue&type=style&index=0&id=4d7155c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7155c0"]])

export default __exports__